<template>
    <div class="mainContent">
        <div v-for="(item, index) in estimate" :key="index">
            <button :class="item.active ? 'active' : 'defaultBtn'" @click="selectItem(item, 'estimate')" class="estimate">{{
                item.value
            }}</button>
        </div>

        <div v-for="(priority, index) in priorityData" :key="index">
            <button :class="priority && priority.active ? 'active' : 'defaultBtn'" @click="selectItem(priority, 'priority')"
                class="priority">
                {{ priority.display_value }}
            </button>
        </div>
    </div>
</template>
  
<script>
import EnumService from "@/api/service/Enum/EnumService";

export default {
    data() {
        return {
            estimate: [
                { value: '30m', active: false, data_value: '0-30' },
                { value: '1 hr', active: false, data_value: '31-60' },
                { value: '2 hr', active: false, data_value: '61-120' },
                { value: '4 hr', active: false, data_value: '121-240' },
                { value: '8 hr', active: false, data_value: '241-480' },
                { value: '>8', active: false, data_value: '>480' }
            ],
            priorityData: [
                { display_value: 'High', data_value: 'high', active: false },
                { display_value: 'Low', data_value: 'low', active: false },
                { display_value: 'Medium', data_value: 'medium', active: false },
                { display_value: 'Critical', data_value: 'critical', active: false }
            ]
        };
    },

    created() {
        this.getPriorityData();
    },

    methods: {
        selectItem(item, group) {
            if (group === 'estimate') {
                let index = this.estimate.findIndex(k => k.value === item.value);
                if (index >= 0) {
                    this.estimate[index].active = !this.estimate[index].active;
                }
            }
            if (group === 'priority') {
                let index = this.priorityData.findIndex(k => k.data_value === item.data_value || k.display_value === item.display_value);
                if (index >= 0) {
                    this.priorityData[index].active = !this.priorityData[index].active;
                }
            }
            this.getSelectedFilter();
        },
        getSelectedFilter() {
            let selectedEstimates = [];
            this.estimate.forEach(k => {
                if (k.active) {
                    selectedEstimates.push(k.data_value);
                }
            });

            let selectedPriorities = [];
            this.priorityData.forEach(k => {
                if (k.active && k.data_value) {
                    selectedPriorities.push(k.data_value);
                }
            });

            let filterData = {
                estimate: selectedEstimates.length > 0 ? selectedEstimates.join(',') : null,
                priority: selectedPriorities.length > 0 ? selectedPriorities.join(',') : null
            };

            Object.keys(filterData).forEach(k => {
                if (!filterData[k]) {
                    delete filterData[k];
                }
            });

            this.$emit('selected-values', filterData);
        },

        async getPriorityData() {
            try {
                let res = await EnumService.findAllDomain({ domain: "PRIORITY" });
                if (res && res.length > 0) {
                    this.priorityData = res.map(item => ({
                        display_value: item.display_value || item.name || item.code,
                        data_value: (item.data_value || item.code || item.name || item.display_value || '').toLowerCase(),
                        active: false
                    }));
                }
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style scoped>
.mainContent {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.defaultBtn {
    white-space: nowrap;
    text-transform: capitalize;
    color: #000;
    font-size: 10px;
    font-weight: 700;
    width: fit-content;
    padding: 0px 15px;
    height: 24px;
    border-radius: 4px;
    opacity: 0.5;
}

.estimate {
    border: 2px solid #ffbe65;
    background: #f9ecda;
}

.priority {
    border: 2px solid #0cb99a;
    background: #d1ffbd;
}

.issueType {
    border: 2px solid #240cb9;
    background: #d3cdf8;
}

.active {
    text-transform: capitalize;
    color: #000;
    font-size: 10px;
    font-weight: 700;
    width: fit-content;
    padding: 0px 15px;
    height: 24px;
    border-radius: 4px;
    opacity: 1;
}
</style>
  